import { render, staticRenderFns } from "./MembershipCreateStepInformation.vue?vue&type=template&id=b85700a8"
import script from "./MembershipCreateStepInformation.vue?vue&type=script&lang=js"
export * from "./MembershipCreateStepInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports